import common from "../common";
import GelButton from "../ui/gel/GelButton";
import GelScene from "../ui/gel/GelScene";

export default class PauseScene extends GelScene {
    constructor() {
        super();

        this._overlay = null;
        this._panel = null;
    }

    init() {
        super.init();

        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.height = P3.View.height;
        this._overlay.alpha = 0.7;
        this._overlay.tint = 0x0;
        //this._overlay.visible = false;
        this.addChild(this._overlay);

        const width = $("#" + P3.View.holder.id).width() >= 770 ? 1000 : 820;

        this._panel = new PIXI.Container();
        this._panel.position.set(common.STAGE_WIDTH * 0.5, 384);
        this._panel.scale.set(0.8);
        //this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_help_scroll_bg_50pcwidth"), 180, 20, 180, 20);
        this._panel.image.width = width;
        this._panel.image.height = 480;
        this._panel.image.pivot.set(this._panel.image.width * 0.5, this._panel.image.height * 0.5);
        this._panel.addChild(this._panel.image);

        this._panel.left = new PIXI.Sprite(P3.assets.texture("ui_help_scroll_fg"));
        this._panel.left.x = -this._panel.image.width * 0.5;
        //this._panel.left.position.set(-30, 0);
        this._panel.left.anchor.set(0.5);
        this._panel.addChild(this._panel.left);

        this._panel.right = new PIXI.Sprite(P3.assets.texture("ui_help_scroll_fg"));
        this._panel.right.x = this._panel.image.width * 0.5;
        //this._panel.right.position.set(30, 0);
        this._panel.right.anchor.set(0.5);
        this._panel.addChild(this._panel.right);

        /*
        if (common.renderer instanceof PIXI.WebGLRenderer) {
            this._panel.image.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
            this._panel.image.mask.x = this._panel.image.width * 0.5;
            this._panel.image.mask.width = Math.abs(this._panel.left.x - this._panel.right.x);
            this._panel.image.mask.height = this._panel.image.height;
            this._panel.image.mask.anchor.set(0.5, 0);
            this._panel.image.mask.tint = 0xFF0000;
            this._panel.image.addChild(this._panel.image.mask);
        } else {
            this._panel.image.mask = new PIXI.Graphics();
            this._panel.image.mask.x = this._panel.image.width * 0.5;
            this._panel.image.mask.beginFill(0xFF0000, 1);
            this._panel.image.mask.drawRect(
                -Math.abs(this._panel.left.x - this._panel.right.x) * 0.5,
                0,
                Math.abs(this._panel.left.x - this._panel.right.x),
                this._panel.image.height
            );
            this._panel.image.mask.endFill();
            this._panel.image.addChild(this._panel.image.mask);
        }
        */

        this.initTitle("Paused");

        this.initHomeButton(1);
        this.initMuteButton(2);
        this.initSettingsButton(3);
        this.initRestartButton(4);
        this.initPlayButton(5, GelButton.POSITION_MIDDLE_TWO_RIGHT);
        this.initHelpButton(6);
    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();

        this._overlay.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
        this._overlay.width = P3.View.width;
    }

    animateIn() {
        if (this.parent === null) return;

        super.animateIn();

        /*
        let to = this._overlay.alpha;
        this._overlay.alpha = 0;
        new P3.utils.TWEEN.Tween(this._overlay, this._tweens)
            .to({alpha: to}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(() => {
                this._overlay.visible = true;
            })
            .start();

        to = this._panel.y;
        this._panel.y += 460;
        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
           .to({y: to}, 340)
           .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
           .delay(140)
           .start();


        this._panel.scale.set(0);
        new P3.utils.TWEEN.Tween(this._panel.scale, this._tweens)
           .to({x: 0.8, y: 0.8}, 340)
           .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
           .delay(140)
           .onStart(() => {
               this._panel.visible = true;
           })
           .onComplete(() => {
               new P3.utils.TWEEN.Tween(this._panel.left, this._tweens)
                   .to({x: -this._panel.image.width * 0.5}, 440)
                   .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                   .start();

               new P3.utils.TWEEN.Tween(this._panel.right, this._tweens)
                   .to({x: this._panel.image.width * 0.5}, 440)
                   .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                   .onUpdate(() => {
                       this._panel.image.mask.width = Math.abs(this._panel.left.x - this._panel.right.x);
                   })
                   .onComplete(() => {
                   })
                   .start();
           })
           .start();
           */
    }

    onRestartButtonClick(button) {
        super.onRestartButtonClick(button);

        // tracking
        common.gmi.sendStatsEvent("level", "restart");
    }

    onHelpButtonClick(button) {
        super.onHelpButtonClick(button);

        // tracking
        common.gmi.sendStatsEvent("howtoplay", "click");
    }
}